/** enforces maxChars on input-components that supports it. */
const enforceMaxChars = false;

export { enforceMaxChars };
